import React, { Component, createRef } from 'react'

import { withRouter } from 'react-router-dom'

import { InputSwitch } from "primereact/inputswitch";
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber'
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea'
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar'
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { RadioButton } from 'primereact/radiobutton'
import { Checkbox } from 'primereact/checkbox'
import { SelectButton } from 'primereact/selectbutton'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { uniqueId } from "lodash"
import filesize from 'filesize'

import NavBar from '../../componentes/Navbar'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'

import PessoaService from '../../app/service/PessoaService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoPessoasUsuariosService from '../../app/service/GrupoPessoasUsuariosService'
import GrupoPessoasService from '../../app/service/GruposPessoasService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import UploadPessoaService from '../../app/service/UploadPessoaService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import AtendimentoService from '../../app/service/AtendimentoService'
import HistoricoPessoaService from '../../app/service/HistoricoPessoaService'
import UnidadeAtendimentoService from '../../app/service/UnidadeAtendimentoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import Logo from '../../pages/seguranca/img/kleiton.JPG'
import './pessoa.css'

class ConsultarPessoa extends React.Component {
  constructor(props) {
    super(props);

    this.pessoaService = new PessoaService();
    this.grupoPessoaUsuariosService = new GrupoPessoasUsuariosService();
    this.grupoPessoasService = new GrupoPessoasService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.uploadPessoaService = new UploadPessoaService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.atendimentoService = new AtendimentoService();
    this.historicoPessoaService = new HistoricoPessoaService();
    this.unidadeAtendimentoService = new UnidadeAtendimentoService();

    this.onTipoPessoaChange = this.onTipoPessoaChange.bind(this);
    this.onChangePerfil = this.onChangePerfil.bind(this);
    this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
    this.onChangeTipoEndereco = this.onChangeTipoEndereco.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
    this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.acoesProcessos = this.acoesProcessos.bind(this);
    this.onChangeTipoConta = this.onChangeTipoConta.bind(this);
    this.acoesHistorico = this.acoesHistorico.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.onChangeCaptador = this.onChangeCaptador.bind(this);
    this.onChangeGrupoPessoas = this.onChangeGrupoPessoas.bind(this);
    this.renderFooterHistorico = this.renderFooterHistorico.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.onCheckedNovoAtendimeno = this.onCheckedNovoAtendimeno.bind(this);

    this.state = {
      pessoa: null,
      codigo: '',
      statusPessoa: null,
      nome: '',
      labelNome: '',
      tipoPessoa: null,
      perfil: null,
      perfis: [],
      dataNascimento: '',
      idade: '',
      profissao: '',
      atividadeEconomica: '',
      estadoCivil: null,
      estadosCivil: [],
      cpfCnpj: '',
      rg: '',
      senhaInss: '',
      passaporte: '',
      tituloEleitor: '',
      reservista: '',
      pis: '',
      cnh: '',
      ctps: '',
      nomeMae: '',
      nomePai: '',
      naturalidade: '',
      nacionalidade: '',
      email: '',
      telefone1: '',
      telefone2: '',
      endereco: '',
      numero: '',
      tipoEndereco: null,
      tipoContato: null,
      bairro: '',
      cep: '',
      estado: null,
      estados: [],
      cidade: null,
      cidades: [],
      contaCorrente: '',
      tipoConta: '',
      agencia: '',
      banco: '',
      pix: '',
      variacaoPoupanca: '',
      observacao: '',
      status: '',
      classeDiv: '',
      detail: '',
      defineTipoPessoa: {},
      defineTipoPessoaJuridica: {},
      processos: [],
      //Arquivos
      upLoadFiles: [],
      nome: '',
      descricao: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      captadores: [],
      captador: null,
      grupoPessoas: [],
      grupoCliente: null,
      //Atendimentos
      atendimentos: [],
      openSpinner: false,
      //Hitórico de Pessoas
      historico: [],
      modalHistorico: false,
      descricaoHistorico: '',
      dataCadastro: '',
      dataUltimaAlteracao: '',
      codigoHistorico: '',
      //Exibição de Arquivo
      fileName: '',
      fileData: null,
      modalExibirArquivo: false,
      //Unidade de Atendimento
      unidades: [],
      unidade: null,
      ficha: '',
      //Foto de cliente
      files: [],
      fotoUrl: null,
      carregando: false,
      tipoNome: '',
      statusNome: '',
      statusChecked: true,
      //Novo Endereçamento e contatos
      enderecos: [],
      contatos: [],
      modalEndereco: false,
      modalContato: false,
      contatoTelefonico: '',
      labelModal: '',
      operacao: '',
      enderecoEditar: null,
      contatoEditar: null,
      //Novo Atendimento
      novoAtendimento: false,
      dataUltimoAtendimento: '',
    };

    this.tipoEndereco = [
      {codigo: 'RUA', nome: 'RUA'},
      {codigo: 'AVENIDA', nome: 'AVENIDA'},
      {codigo: 'TRAVESSA', nome: 'TRAVESSA'},
      {codigo: 'PRACA', nome: 'PRACA'},
      {codigo: 'RODOVIA', nome: 'RODOVIA'},
      {codigo: 'ESTRADA', nome: 'ESTRADA'},
      {codigo: 'ALAMEDA', nome: 'ALAMEDA'},
      {codigo: 'LARGO', nome: 'LARGO'},
      {codigo: 'BECO', nome: 'BECO'},
      {codigo: 'VIA', nome: 'VIA'}
    ];

    this.tipoContato = [
      {codigo: 'CELULAR', nome: 'CELULAR'},
      {codigo: 'FIXO', nome: 'FIXO'},
      {codigo: 'WHATSAPP', nome: 'WHATSAPP'}
    ]

    this.fileInputRef = createRef();

    this.tipoPessoa = [
      {codigo: 'F', nome: 'Física'},
      {codigo: 'J', nome: 'Jurídica'}
    ];

    this.status = [
      {codigo: '0', nome: 'Ativo'},
      {codigo: '1', nome: 'Inativo'}
    ];

    this.conta = [
      {codigo: 'C', nome: 'Conta Corrente'},
      {codigo: 'P', nome: 'Poupança'}
    ]

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });
  }

  listarUnidadesAtendimento = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.unidadeAtendimentoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({unidades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Pessoas - Unidades de Atendimento', detail:`${this.state.detail}`, life: 4000});
      })
  }

  cadastrarHistoricoPessoa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.descricaoHistorico == '') {
      this.toast.show({severity:'error', summary: 'Histórico de Pessoas', detail:'Informe o histórico', life: 4000});
      return;
    }
    const historico = {
      pessoa: this.state.pessoa,
      dsHistorico: this.state.descricaoHistorico,
      usuario: usuarioLogado
    }

    this.setState({openSpinner: true});
    await this.historicoPessoaService.cadastrarHistorico(historico)
      .then(response => {
        this.listarHistoricoPessoas();
        this.toast.show({severity:'success', summary: 'Histórico de Pessoas', detail:'Histórico cadastrado com sucesso', life: 4000});
        this.fecharModalCadastro('modalHistorico');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarHistoricoPessoas = async () => {
    await this.historicoPessoaService.listarPorPessoa(this.state.pessoa.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  renderFooterHistorico(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarHistoricoPessoa}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  onChangeCaptador(e) {
    this.setState({captador: e.value});
  }

  listarCaptadores = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.pessoaService.listarCaptadores('CP', usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({captadores: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onChangeGrupoPessoas(e) {
    this.setState({grupoCliente: e.value});
  }

  listarGruposPessoas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoPessoasService.listarGrupos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({grupoPessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas - Consulta de Grupo de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarAtendimentos = (pessoa) => {
    this.atendimentoService.consultarAtendimentosPorPessoa(pessoa)
      .then(response => {
        this.setState({atendimentos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistorico(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text" 
                tooltip="Excluir"
                onClick={() => this.confirmaExclusaoHistorico(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({codigoHistorico: historico.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o histórico selecionado ?',
        header: 'Exclusão de histórico',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  async acceptExcluirHistorico() {
    await this.excluirHistorico();
  }

  excluirHistorico = async () => {
    this.setState({openSpinner: true});
    await this.historicoPessoaService.excluirHistorico(this.state.codigoHistorico)
      .then(response => {
        this.listarHistoricoPessoas();
        this.toast.show({severity:'success', summary: 'Exclusão de Histórico', detail:'Histórico excluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Exclusão de Histórico', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});

  }

  consultarAtendimento(atendimento) {
    this.props.history.push(`/historicoAtendimento/${atendimento.codigo}/pessoa/${this.state.pessoa.codigo}`);    
  }

  onChangeTipoConta(e) {
    this.setState({tipoConta: e.value})
  }

  onChangeDefineTipoPessoa = () => {
    if(this.state.tipoPessoa === 'J') {
      this.setState({defineTipoPessoa: {
        display: 'none'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'block'
      }});
      this.setState({labelNome: 'Empresa'});
    } else {
      this.setState({defineTipoPessoa: {
        display: 'block'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'none'
      }});
      this.setState({labelNome: 'Nome'});
    }
  }

  async onChangeTipoPessoa(e) {
    await this.setState({tipoPessoa: e.value});
    this.onChangeDefineTipoPessoa();
  }

  async componentDidMount() {
    const params = this.props.match.params;
    if(params.codigo) {
      this.setState({openSpinner: true});
      await this.consultarPessoa(params.codigo);
      this.setState({openSpinner: false});
    }
  }

  listarPerfisPessoa = async () => {
    await this.pessoaService.listarPerfilPessoa()
      .then(response => {
        this.setState({perfis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de perfis de pessoa', life: 4000});
      })
  }

  onChangePerfil(e) {
    this.setState({perfil: e.value});
  }

  listarEstadosCivil = async () => {
    await this.pessoaService.listarEstadoCivil()
      .then(response => {
        this.setState({estadosCivil: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de estados civis', life: 4000});
      })
  }

  onChangeEstadoCivil(e) {
    this.setState({estadoCivil: e.value});
  }

  listarTiposEndereco = async () => {
    await this.pessoaService.listarTiposEndereco()
      .then(response => {
        this.setState({tiposEndereco: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de endereço', life: 4000});
      })
  }

  onChangeTipoEndereco(e) {
    this.setState({tipoEndereco: e.value});
  }

  onTipoPessoaChange(e) {
    this.setState({tipoPessoa: e.value});
  }

  listarEstados = async () => {
    this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar Estados', life: 4000});
      });
  }

  async onChangeEstado(e) {
    if(e.value != null) {
      await this.setState({estado: e.value});
      this.setState({openSpinner: true});
      await this.listarCidades();
      this.setState({openSpinner: false});
    } else {
      this.setState({estado: null});
      this.setState({cidade: null});
      this.setState({cidades: []});
    }
  }

  listarCidades = () => {
    this.cidadeService.listarCidades(this.state.estado.codigo)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar Cidades', life: 4000});
      })
  }

  onChangeCidade(e) {
    this.setState({cidade: e.value});
  }

  onChangeEstadoCivil(e) {
    this.setState({estadoCivil: e.value});
  }

  async consultarPessoa(codigo) {
    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoa(codigo)
      .then(response => {
        this.setState({pessoa: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        if(response.data.tipoPessoa === 'F') {
          this.setState({tipoNome: 'FÍSICA'});
          this.setState({tipoPessoa: {
            codigo: 'F', nome: 'Física'
          }});
          this.setState({defineTipoPessoa: {display: 'block'}});
          this.setState({defineTipoPessoaJuridica: {display: 'none'}});
          this.setState({labelNome: 'Nome'});
        } else {
          this.setState({tipoNome: 'JURÍDICA'});
          this.setState({tipoPessoa: {
            codigo: 'J', nome: 'Jurídica'
          }});
          this.setState({defineTipoPessoa: {display: 'none'}})
          this.setState({defineTipoPessoaJuridica: {display: 'block'}});
          this.setState({labelNome: 'Empresa'});
        }
        this.setState({situacaoPessoa: response.data.situacaoPessoa});
        if(response.data.dataNascimento != '' && response.data.dataNascimento != null) {
          var dataNasc = new Date(response.data.dataNascimento);
          dataNasc.setDate(dataNasc.getDate()+1)
          this.setState({dataNascimento: new Date(Date.parse(dataNasc))})
          this.setState({idade: response.data.idade})
        }
        this.setState({profissao: response.data.profissao});
        this.setState({atividadeEconomica: response.data.atividadeEconomica});
        this.setState({estadoCivil: response.data.estadoCivil});
        this.setState({cpfCnpj: response.data.cpfCnpj});
        this.setState({rg: response.data.rg});
        this.setState({senhaInss: response.data.senhaSerasa});
        this.setState({passaporte: response.data.passaporte});
        this.setState({tituloEleitor: response.data.tituloEleitor});
        this.setState({reservista: response.data.reservista});
        this.setState({pis: response.data.pis});
        this.setState({cnh: response.data.cnh});
        this.setState({ctps: response.data.ctps});
        this.setState({nomeMae: response.data.nomeMae});
        this.setState({nomePai: response.data.nomePai});
        this.setState({naturalidade: response.data.naturalidade});
        this.setState({nacionalidade: response.data.nacionalidade});
        this.setState({perfil: response.data.perfil});
        this.setState({grupoCliente: response.data.grupoCliente});
        this.setState({captador: response.data.captador});
        this.setState({enderecos: response.data.enderecos});
        this.setState({contatos: response.data.contatos})
        if(response.data.tipoConta != null) {
          if(response.data.tipoConta == 'P') {
            this.setState({tipoConta: {
              codigo: 'P',
              nome: 'Poupança'
            }});
          } else {
            this.setState({tipoConta: {
              codigo: 'C',
              nome: 'Conta Corrente'
            }})
          }
        }
        this.setState({contaCorrente: response.data.contaCorrente});
        this.setState({agencia: response.data.agencia});
        this.setState({banco: response.data.banco});
        this.setState({pix: response.data.pix});
        this.setState({variacaoPoupanca: response.data.variacaoPoupanca})
        this.setState({observacao: response.data.observacao});
        this.setState({unidade: response.data.unidadeAtendimento})
        if(response.data.status == '0') {
          this.setState({statusNome: 'ATIVO'});
          this.setState({statusPessoa: {
            codigo: '0', nome: 'Ativo'
          }});
        } else {
          this.setState({statusNome: 'INATIVO'})
          this.setState({statusPessoa: {
            codigo: '1', nome: 'Inativo'
          }});
        }
        this.setState({historico: response.data.historico});
        var dataCadastro = new Date(response.data.dataCadastro);
        dataCadastro.setDate(dataCadastro.getDate()+1)
        this.setState({dataCadastro: dataCadastro});
        var ultimaAlteracao = new Date(response.data.dataUltimaAlteracao);
        ultimaAlteracao.setDate(ultimaAlteracao.getDate()+1)
        this.setState({dataUltimaAlteracao: ultimaAlteracao});
        this.setState({dataUltimoAtendimento: response.data.dataUltimoAtendimento})
        this.listarPerfisPessoa();
        this.listarEstadosCivil();
        this.listarTiposEndereco();
        this.listarGruposPessoas();
        this.listarCaptadores();
        this.listarUnidadesAtendimento();
        this.listarArquivosPessoa(response.data.codigo);
        this.consultarProcessos(response.data.codigo);
        this.consultarAtendimentos(response.data.codigo);
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      });
      await this.loadFoto();
      this.setState({openSpinner: false});
  }

  consultarProcessos = async (pessoa) => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.consultarProcessos(pessoa, usuarioLogado.codigo)
      .then(response => {
        this.setState({processos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesProcessos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-search" className="p-button-rounded p-button-text" 
                tooltip="Editar"
                onClick={() => this.editarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  editarProcesso(processo) {
    //this.props.history.push(`/fichaProcesso/${processo.codigo}`);
    window.open(`/#/fichaProcesso/${processo.codigo}/SEARCH`, "_blank")
  }

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('pessoa',upLoadFile.file, this.state.codigo); //Envia código da pessoa para criar diretório
    data.append('usuario', upLoadFile.file, usuarioLogado.codigo);
    
    await this.arquivoPessoaService.incluirArquivoNovoMetodo(data)
      .then(response => {
        this.listarArquivosPessoa(this.state.codigo);
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        console.log('Error ', error);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosPessoa = async (codigo) => {
    await this.arquivoPessoaService.listarArquivos(codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  async consultarArquivo(codigo) {
    await this.arquivoPessoaService.consultarArquivo(codigo)
      .then(response => {
        this.setState({arquivo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarArquivoDescricao(rowData) {
    await this.arquivoPessoaService.consultarArquivo(rowData.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
        this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }


  async exibirArquivo_old(arquivo){
    this.setState({openSpinner: true});
    await this.arquivoPessoaService.exibirArquivo(arquivo.arquivo,this.state.codigo)
      .then(response => {
        const url = URL.createObjectURL(response.data); // Cria uma URL local para o arquivo
        this.setState({fileData: url});
        this.setState({fileName: arquivo.arquivo});
        this.abrirModal('modalExibirArquivo');
      }).catch(error => {
        this.setState({openSpinner: false});
        console.error("Erro ao buscar o arquivo", error);
      });
      this.setState({openSpinner: false});
  } 
	
	async exibirArquivo(arquivo) {
    this.setState({ openSpinner: true });

    try {
      const response = await this.arquivoPessoaService.exibirArquivo(arquivo.arquivo,this.state.codigo)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      });

      const url = URL.createObjectURL(blob);

      this.setState({
        fileData: url,
        fileName: arquivo.arquivo,
        modalExibirArquivo: true
      });

    } catch (error) {
      console.error("Erro ao buscar o arquivo", error);
    } finally {
      this.setState({ openSpinner: false });
    }
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={() => this.adicionarDescricao()}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  async adicionarDescricao(){
    await this.arquivoPessoaService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosPessoa(this.state.pessoa.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({descricaoHistorico: ''});
    this.setState(state);
  }

  excluirArquivo = async () => { 
    this.setState({openSpinner: true});
    await this.arquivoPessoaService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosPessoa(this.state.pessoa.codigo);
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  async download (rowData){
    console.log('RowData ', rowData);
    //await this.consultarArquivo(rowData.codigo);
    await this.arquivoPessoaService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', rowData.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('Erro ', error)
      })
  }

  async downloadArquivo(rowData){
    await this.arquivoPessoaService.download(rowData.codigo)
    .then(response => {
      // Se você já tem o nome do arquivo salvo no estado, use ele
      const nomeArquivo = response.data.aquivo || 'arquivo.pdf';

      // Cria um blob com os dados da resposta
      const blob = new Blob([response.data]);

      // Cria uma URL temporária para o blob
      const url = window.URL.createObjectURL(blob);

      // Cria um link e simula o clique para download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo); 
      document.body.appendChild(link);
      link.click();

      // Limpeza
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.log('Erro ao baixar o arquivo:', error);
      alert('Erro ao baixar o arquivo');
    });
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-images" className="p-button-rounded p-button-text"
                tooltip="Exibir Arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.exibirArquivo(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }


  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  alterarPessoa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    //Data de nascmento
    var dataFormatadaDataNascimento = null;
    if(this.state.dataNascimento != '' && this.state.dataNascimento != null) {
      var date = this.state.dataNascimento;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDataNascimento =  year+"-"+month+"-"+day;
    }
    this.setState({openSpinner: true});
    await this.pessoaService.alterarPessoa({
      codigo: this.state.pessoa.codigo,
      tipoPessoa: this.state.tipoPessoa.codigo,
      status: this.state.statusPessoa.codigo,
      nome: this.state.nome,
      perfil: this.state.perfil,
      dataNascimento: dataFormatadaDataNascimento,
      profissao: this.state.profissao,
      atividadeEconomica: this.state.atividadeEconomica,
      estadoCivil: this.state.estadoCivil,
      cpfCnpj: this.state.cpfCnpj,
      rg: this.state.rg,
      senhaSerasa: this.state.senhaInss,
      passaporte: this.state.passaporte,
      tituloEleitor: this.state.tituloEleitor,
      reservista: this.state.reservista,
      pis: this.state.pis,
      cnh: this.state.cnh,
      ctps: this.state.ctps,
      nomeMae: this.state.nomeMae,
      nomePai: this.state.nomePai,
      grupoCliente: this.state.grupoCliente,
      captador: this.state.captador,
      naturalidade: this.state.naturalidade,
      nacionalidade: this.state.nacionalidade,
      enderecos: this.state.enderecos,
      contatos: this.state.contatos,
      tipoConta: this.state.tipoConta.codigo,
      contaCorrente: this.state.contaCorrente,
      agencia: this.state.agencia,
      banco: this.state.banco,
      pix: this.state.pix,
      variacaoPoupanca: this.state.variacaoPoupanca,
      observacao: this.state.observacao,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado.codigo,
      unidadeAtendimento: this.state.unidade,
      snNovoAtendimento: this.state.novoAtendimento ? 'S' : 'N'
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Edição de Pessoas', detail:'Pessoa alterada com sucesso!', life: 4000});
      this.consultarPessoa(this.state.pessoa.codigo);
    }).catch(error => {
      this.setState({openSpinner: false}); 
      this.toast.show({severity:'error', summary: 'Edição de Pessoas', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({openSpinner: false});
  }

  voltar = () => {
    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_pessoa_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaFiltroJson != null) {
      let params = `/pessoas?empresa=${consultaFiltroJson.empresa}&usuario=${consultaFiltroJson.usuario}`;
      
      if(consultaFiltroJson.nome != null) {
        params = `${params}&nome=${consultaFiltroJson.nome}`;
      }
  
      if(consultaFiltroJson.cpfCnpj != null) {
        params = `${params}&cpfCnpj=${consultaFiltroJson.cpfCnpj}`;
      }
  
      if(consultaFiltroJson.cidade != null) {
        params = `${params}&cidade=${consultaFiltroJson.cidade}`;
      }
  
      if(consultaFiltroJson.telefone != null) {
        params = `${params}&telefone=${consultaFiltroJson.telefone}`;
      }
  
      if(consultaFiltroJson.porLetra != null) {
        params = `${params}&letra=${consultaFiltroJson.letra}&porLetra=${consultaFiltroJson.porLetra}`;
      }
  
      if(consultaFiltroJson.grupo != null) {
        params = `${params}&grupo=${consultaFiltroJson.grupo}`;
      }

      this.props.history.push(params);

    } else {
      this.props.history.push('/pessoas')
    }
  }

  imprimirFicha = () => {

    this.setState({ficha: `#/fichaPessoa/${this.state.codigo}`});

    //this.props.history.push('/fichaPessoa')
  }


  handleUploadFoto = async (selectedFile) => {
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("file", selectedFile);

    this.setState({ carregando: true });
    try {

      await this.pessoaService.uploadFoto(this.state.pessoa.codigo,formData)
        .then(response => {
          const previewUrl = URL.createObjectURL(selectedFile);
          this.setState({ fotoUrl: previewUrl });
        })
    } catch (error) {
      console.error(error);
      alert("Erro ao enviar foto");
    }

    finally {
      this.setState({ carregando: false });
    }
  };
  

  onFileChange = (e) => {
    const selectedFile = e.target.files[0];
    this.handleUploadFoto(selectedFile);
  };

  onClickFrame = () => {
    if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  }

  loadFoto = async () => {
    await this.pessoaService.carregarFoto(this.state.pessoa.codigo)
      .then((response) => {
        if(response.data.size == 0) {
          this.setState({fotoUrl: null});
        } else {
          const imageUrl = URL.createObjectURL(response.data);
          this.setState({ fotoUrl: imageUrl });
        }
      }).catch(error => {
        console.log('Erro ', error);
      })
  }

  ativarEdicao = () => {
    this.setState({ editandoNome: true });
  };

  // salvar nome ao sair do input
  salvarNome = () => {
    this.setState({ editandoNome: false });
    console.log('Novo nome editado ', this.state.nome);                                                                                             
  };

  onChangeNome = (e) => {
    this.setState({ nome: e.target.value });
  };

  onChangeStatusPessoa = (e) => {
    if(e.value == true) {
      this.setState({statusNome: 'ATIVO'});
      this.setState({statusChecked: true});
    } else {
      this.setState({statusNome: 'INATIVO'});
      this.setState({statusChecked: false});
    }
  }

  removerFoto = async () => {
    this.setState({openSpinner: true});
    await this.pessoaService.removerFoto(this.state.pessoa.codigo)
      .then(response => {
        this.loadFoto();
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'remover Foto', detail:`${error}`, life: 4000});
      })
  }

  novoEndereco = async () => {
    this.setState({labelModal: 'Cadastrar Endereço'});
    this.setState({tipoEndereco: null});
    this.setState({endereco: ''});
    this.setState({cep: ''});
    this.setState({bairro: ''});
    this.setState({complemento: ''});
    this.setState({openSpinner: true});
    this.setState({estado: null});
    this.setState({cidade: null});
    this.setState({operacao: 'INSERT'});
    await this.listarEstados();
    this.setState({openSpinner: false});
    this.abrirModal('modalEndereco');
  }

  adicionarEndereco = async () => {
    if (this.state.cidade == null) {
      this.toast.show({
        severity: "error",
        summary: "Endereço",
        detail: "Informe a Cidade",
        life: 4000,
      });
      return;
    }
  
    var tipoEndereco = "";
    if (this.state.tipoEndereco != null) {
      tipoEndereco = this.state.tipoEndereco.codigo;
    }
  
    const endereco = {
      endereco: this.state.endereco,
      cep: this.state.cep,
      bairro: this.state.bairro,
      complemento: this.state.complemento,
      cidade: this.state.cidade,
      tipoEndereco: tipoEndereco,
    };
  
    let enderecos = [...this.state.enderecos];
  
    if (this.state.operacao === "UPDATE") {
      // procura o índice do endereço que está sendo editado
      const index = enderecos.findIndex(
        (e) => e === this.state.enderecoEditar
      );
  
      if (index !== -1) {
        enderecos[index] = endereco; // substitui o objeto
      }
    } else {
      // operação normal de ADD
      enderecos.push(endereco);
    }
  
    this.setState({ enderecos });
    this.fecharModalCadastro("modalEndereco");
  };

  excluirEndereco(enderecoParaRemover) {
    this.setState((prevState) => ({
      enderecos: prevState.enderecos.filter(
        (endereco) => endereco !== enderecoParaRemover
      ),
    }));
  }

  excluirContato(contatoRemover) {
    this.setState((prevState) => ({
      contatos: prevState.contatos.filter(
        (contato) => contato !== contatoRemover
      ),
    }));
  }

  novoContato = () => {
    this.setState({tipoContato: null});
    this.setState({contatoTelefonico: ''});
    this.setState({email: ''});
    this.setState({operacao: 'INSERT'});
    this.setState({labelModal: 'Incluir Contato'});
    this.abrirModal('modalContato');
  }

  adicionarContato = async () => {
    if (this.state.tipoContato == null) {
      this.toast.show({
        severity: "error",
        summary: "Contato",
        detail: "Informe o Tipo de Contato",
        life: 4000,
      });
      return;
    }

    if (this.state.contatoTelefonico == '') {
      this.toast.show({
        severity: "error",
        summary: "Contato",
        detail: "Informe um contato",
        life: 4000,
      });
      return;
    }
  
    const contato = {
      tipoTelefone: this.state.tipoContato.codigo,
      telefone: this.state.contatoTelefonico,
      email: this.state.email
    };
  
    let contatos = [...this.state.contatos];
  
    if (this.state.operacao === "UPDATE") {
      // procura o índice do endereço que está sendo editado
      const index = contatos.findIndex(
        (e) => e === this.state.contatoEditar
      );
  
      if (index !== -1) {
        contatos[index] = contato; // substitui o objeto
      }
    } else {
      // operação normal de ADD
      contatos.push(contato);
    }
  
    this.setState({ contatos });
    this.fecharModalCadastro("modalContato");
  };

  async editarEndereco(endereco) {
    this.setState({enderecoEditar: endereco});
    this.setState({labelModal: 'Alterar Endereço'})
    this.setState({tipoEndereco: this.retornaTipoEndereco(endereco.tipoEndereco)});
    this.setState({endereco: endereco.endereco});
    this.setState({bairro: endereco.bairro});
    this.setState({cep: endereco.cep});
    this.setState({estado: endereco.cidade.estado})
    this.setState({cidade: endereco.cidade});
    this.setState({complemento: endereco.complemento});
    this.setState({operacao: 'UPDATE'});
    this.setState({openSpinner: true});
    await this.listarEstados();
    await this.listarCidades();
    this.setState({openSpinner: false});
    this.abrirModal('modalEndereco');
  }

  editarContato(contato) {
    this.setState({labelModal: 'Alterar Contato'});
    this.setState({contatoEditar: contato});
    this.setState({tipoContato: this.retornaTipoContato(contato.tipoTelefone)});
    this.setState({contatoTelefonico: contato.telefone});
    this.setState({email: contato.email});
    this.setState({operacao: 'UPDATE'});
    this.abrirModal('modalContato');
  }

  retornaTipoContato(tipo) {
    for(let i = 0; i < this.tipoContato.length; i++) {
      if(tipo == this.tipoContato[i].codigo) {
        return this.tipoContato[i];
      }
    }
  }

  retornaTipoEndereco(tipo) {
    for(let i = 0; i < this.tipoEndereco.length; i++) {
      if(tipo == this.tipoEndereco[i].codigo) {
        return this.tipoEndereco[i];
      }
    }
  }

  confirmaAtivarInativaePessoa() {
    var mensagem = '';
    if(this.state.pessoa.status == 0) {
      mensagem = 'Deseja realmente inativar a pessoa ?';
    } else {
      mensagem = 'Deseja realmente reativar a pessoa ?';
    }
    confirmDialog({
        message: `${mensagem}`,
        header: 'Ativação/Inativação de Pessoa',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.ativarInativarPessoa,
        reject: this.reject
    });
  }

  ativarInativarPessoa = async () => {
    this.setState({openSpinner: true});
    var mensagem = '';
    if(this.state.pessoa.status == 0) {
      mensagem = 'Pessoa inativada com sucesso!';
    } else {
      mensagem = 'Pessoa reativada com sucesso!';
    }
    await this.pessoaService.ativarInativarPessoa(this.state.pessoa.codigo)
      .then(response => {
        this.consultarPessoa(this.state.pessoa.codigo);
        this.toast.show({severity:'success', summary: 'Alteração de Pessoa', detail:`${mensagem}`, life: 4000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Alteração de Pessoa', detail:`${error}`, life: 4000});
      })
  }

  onCheckedNovoAtendimeno(e) {
    if(e.checked) {
      this.setState({novoAtendimento: true});
    } else {
      this.setState({novoAtendimento: false});
    }
  }

  render() {
    const { upLoadFiles } = this.state;
    const { nome } = this.props;
    const { fotoUrl, carregando, editandoNome } = this.state;

    const frameStyle = {
      width: "72px",   // largura (3 partes)
      height: "96px",  // altura  (4 partes) => 3x4
      minWidth: "72px",
      minHeight: "96px",
      borderRadius: "6px",
      overflow: "hidden",
      boxSizing: "border-box",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#fff",
      // borda sempre visível (moldura). Se quiser só quando vazio, mude condicionalmente.
      border: "2px dashed #ccc",
    };

    const imgStyle = {
      width: "100%",
      height: "100%",
      objectFit: "cover", // garante crop proporcional
      display: "block",
    };

    const nameStyle = {
      fontWeight: 600,
      fontSize: "16px",
    };

    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-user-tie"></i>
                    <span> Consulta de Pessoas</span>
                  </h3>  
                </div>
                <div className="card-body">
                  <TabView className="tabview-custom">
                    <TabPanel header="Informações Pessoais">
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <div
                              className="ficha-cliente"
                              style={{ display: "flex", alignItems: "center", gap: "12px" }}
                            >
                              {/* Coluna da foto + botão */}
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                {/* Moldura clicável */}
                                <div
                                  onClick={this.onClickFrame}
                                  style={frameStyle}
                                  title="Clique para alterar foto"
                                >
                                  {carregando ? (
                                    <span style={{ fontSize: 12, color: "#666" }}>Enviando...</span>
                                  ) : fotoUrl ? (
                                    <img src={fotoUrl} alt={`${nome} - foto`} style={imgStyle} />
                                  ) : (
                                    <div style={{ textAlign: "center", padding: "6px" }}>
                                      <div style={{ fontSize: 18 }}>📷</div>
                                      <div style={{ fontSize: 11, color: "#2563eb" }}>
                                        Clique para foto
                                      </div>
                                    </div>
                                  )}

                                  <input
                                    type="file"
                                    accept="image/*"
                                    ref={this.fileInputRef}
                                    onChange={this.onFileChange}
                                    style={{ display: "none" }}
                                  />
                                </div>

                                {/* Link de remover */}
                                {fotoUrl && (
                                  <button
                                    onClick={this.removerFoto}
                                    style={{
                                      marginTop: "6px",
                                      fontSize: "12px",
                                      color: "#dc2626", // vermelho
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    Remover foto
                                  </button>
                                )}
                              </div>

                              {/* Dados do cliente */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  paddingTop: "12px",
                                  paddingLeft: "15px",
                                }}
                              >
                                {editandoNome ? (
                                  <InputText
                                    id="nome"
                                    type="text"
                                    style={{ width: "400px", height: "32px" }}
                                    value={this.state.nome}
                                    onChange={this.onChangeNome}
                                    onBlur={this.salvarNome}
                                    onKeyDown={(e) => e.key === "Enter" && this.salvarNome()}
                                    autoFocus
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                  />
                                ) : (
                                  <div style={nameStyle}>
                                    {this.state.nome || "Nome da Pessoa"}
                                    <span
                                      onClick={this.ativarEdicao}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        color: "#2563eb",
                                      }}
                                      title="Editar nome"
                                    >
                                      &nbsp;&nbsp;✏️
                                    </span>
                                  </div>
                                )}

                                <div style={{  fontSize: 13, color: "#666" }}>
                                  <strong style={{color: 'blue'}}>{this.state.idade}</strong>
                                </div>
                                <div style={{  fontSize: 13, color: "#666" }}>
                                  <strong style={{color: 'blue'}}>Último Atendimento: {this.state.dataUltimoAtendimento}</strong>
                                </div>
                                <br />
                                <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                  <a
                                    style={{ cursor: 'pointer' }}
                                    title={
                                      this.state.statusNome === 'ATIVO'
                                        ? 'Clique aqui para inativar a pessoa'
                                        : 'Clique aqui para ativar a pessoa'
                                    } onClick={() => this.confirmaAtivarInativaePessoa()}
                                  >
                                    <Tag
                                      style={{ width: "100px", height: "25px" }}
                                      severity={this.state.statusNome === 'ATIVO' ? 'success' : 'danger'}
                                      value={this.state.statusNome}
                                    />
                                  </a>
                                  &nbsp;&nbsp;
                                  <Tag
                                    style={{ background: "#ccc", color: "#000", width: "100px", height: "25px" }}
                                    severity="success"
                                    value={this.state.tipoNome}>
                                  </Tag>
                                  &nbsp;&nbsp;
                                  <div style={{ display: "flex", alignItems: "center" }}>
                                    <Checkbox onChange={this.onCheckedNovoAtendimeno} 
                                              checked={this.state.novoAtendimento}></Checkbox>
                                    <label htmlFor="ingredient1" style={{ marginLeft: "4px" }}>
                                      Novo Atendimento
                                    </label>
                                  </div>

                                </div>
                                <br />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Perfil Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.perfil} 
                                      options={this.state.perfis} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangePerfil}
                                      id="perfilPessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Unidade de Atendimento</label>
                            <Dropdown value={this.state.unidade} 
                                      options={this.state.unidades} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({unidade: e.target.value})}
                                      id="unidadeId"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <label style={{ fontWeight: "bold" }}>Endereço</label>
                              <i
                                className="pi pi-plus"
                                style={{
                                  color: "#2563eb", // azul
                                  fontSize: "16px",
                                  cursor: "pointer"
                                }}
                                title="Adicionar endereço"
                                onClick={this.novoEndereco}
                              ></i>
                            </div>
                            <div>
                              {this.state.enderecos && this.state.enderecos.length > 0 ? (
                                this.state.enderecos.map((endereco, index) => {
                                  // Monta dinamicamente apenas os campos existentes
                                  const partes = [
                                    endereco.tipoEndereco,
                                    endereco.endereco,
                                    endereco.bairro,
                                    endereco.cep,
                                    endereco.complemento,
                                    endereco.cidade?.nome,
                                    endereco.cidade?.estado?.estado,
                                  ].filter(Boolean); // remove undefined, null e string vazia

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "8px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {/* String formatada apenas com os valores existentes */}
                                      <span>{partes.join(" - ")}</span>

                                      {/* Ícones de ação */}
                                      <div style={{ display: "flex", gap: "10px" }}>
                                        <span
                                          style={{ cursor: "pointer", color: "#2563eb" }}
                                          title="Editar"
                                          onClick={() => this.editarEndereco(endereco)}
                                        >
                                          ✏️
                                        </span>
                                        <span
                                          style={{ cursor: "pointer", color: "#dc2626" }}
                                          title="Excluir"
                                          onClick={() => this.excluirEndereco(endereco)}
                                        >
                                          🗑️
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <p style={{ fontSize: "14px", color: "#666" }}>Nenhum endereço cadastrado</p>
                              )}
                            </div> 
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <label style={{ fontWeight: "bold" }}>Contato</label>
                              <i
                                className="pi pi-plus"
                                style={{
                                  color: "#2563eb", // azul
                                  fontSize: "16px",
                                  cursor: "pointer"
                                }}
                                title="Adicionar Contato"
                                onClick={this.novoContato}
                              ></i>
                            </div>
                            <div>
                              {this.state.contatos && this.state.contatos.length > 0 ? (
                                this.state.contatos.map((contato, index) => {
                                  // Monta dinamicamente apenas os campos existentes
                                  const partes = [
                                    contato.tipoTelefone,
                                    contato.telefone,
                                    contato.email,
                                  ].filter(Boolean); // remove undefined, null e string vazia

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "8px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {/* String formatada apenas com os valores existentes */}
                                      <span>{partes.join(" - ")}</span>

                                      {/* Ícones de ação */}
                                      <div style={{ display: "flex", gap: "10px" }}>
                                        <span
                                          style={{ cursor: "pointer", color: "#2563eb" }}
                                          title="Editar"
                                          onClick={() => this.editarContato(contato)}
                                        >
                                          ✏️
                                        </span>
                                        <span
                                          style={{ cursor: "pointer", color: "#dc2626" }}
                                          title="Excluir"
                                          onClick={() => this.excluirContato(contato)}
                                        >
                                          🗑️
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <p style={{ fontSize: "14px", color: "#666" }}>Nenhum contato cadastrado</p>
                              )}
                            </div> 
                          </div>
                        </div>
                      </div>

                      {/**Adicionar Endereço */}
                      <Dialog header={this.state.labelModal}
                              visible={this.state.modalEndereco} 
                              style={{ width: '50vw' }} 
                              footer={
                                <div>
                                  <Button label="Salvar" 
                                          className="p-button-success p-button-text"
                                          onClick={this.adicionarEndereco}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModalCadastro('modalEndereco')}/>
                                </div>
                              }
                              onHide={() => this.fecharModalCadastro('modalEndereco')}>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Tipo de Endereço</label>
                                    <Dropdown value={this.state.tipoEndereco} 
                                              options={this.tipoEndereco} style={{width: '100%', height: '32px'}}
                                              optionLabel="nome" 
                                              onChange={e => this.setState({tipoEndereco: e.target.value})}
                                              id="tipoEndereco"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Endereço</label>
                                    <InputText id="endereco" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.endereco}
                                               onChange={e => this.setState({endereco: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="form-group">
                                    <label>CEP</label>
                                    <InputMask id="cep"
                                               type="text"
                                               mask="99999-999"
                                               style={{ width: "100%", height: "32px" }}
                                               value={this.state.cep}
                                               onChange={e => this.setState({cep: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                                <div className="col-sm-8">
                                  <div className="form-group">
                                    <label>Bairro</label>
                                    <InputText id="bairro" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.bairro}
                                               onChange={e => this.setState({bairro: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>Complemento</label>
                                    <InputText id="complemento" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.complemento}
                                               onChange={e => this.setState({complemento: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="form-group">
                                    <label>Estado</label>
                                    <Dropdown value={this.state.estado} 
                                              options={this.state.estados} style={{width: '100%', height: '32px'}}
                                              optionLabel="estado"
                                              filter showClear filterBy="estado"
                                              onChange={this.onChangeEstado}
                                              id="estado"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                                <div className="col-sm-8">
                                  <div className="form-group">
                                    <label>Cidade</label>
                                    <Dropdown value={this.state.cidade} 
                                              options={this.state.cidades} style={{width: '100%', height: '32px'}}
                                              optionLabel="nome"
                                              filter showClear filterBy="nome"
                                              onChange={e => this.setState({cidade: e.target.value})}
                                              id="cidade"
                                              emptyMessage="Nenhuma Cidade"
                                              className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                      </Dialog>
                      {/**Adicionar Contato */}
                      <Dialog header={this.state.labelModal}
                              visible={this.state.modalContato} 
                              style={{ width: '40vw' }} 
                              footer={
                                <div>
                                  <Button label="Salvar" 
                                          className="p-button-success p-button-text"
                                          onClick={this.adicionarContato}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModalCadastro('modalContato')}/>
                                </div>
                              }
                              onHide={() => this.fecharModalCadastro('modalContato')}>
                              <div className="row">
                                <div className="col-sm-4">
                                  <div className="form-group">
                                    <label>Tipo de Contato</label>
                                    <Dropdown
                                      value={this.state.tipoContato}
                                      options={this.tipoContato}
                                      style={{ width: "100%", height: "32px" }}
                                      optionLabel="nome"
                                      onChange={(e) => this.setState({ tipoContato: e.value })}
                                      id="tipoContato"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                    />
                                  </div>
                                </div>

                                <div className="col-sm-8">
                                  <div className="form-group">
                                    <label>Contato</label>
                                    <InputMask
                                      id="contato2"
                                      type="text"
                                      mask={
                                        this.state.tipoContato?.nome === "CELULAR"
                                          ? "(99) 9 9999-9999"
                                          : this.state.tipoContato?.nome === "FIXO"
                                          ? "(99) 9999-9999"
                                          : this.state.tipoContato?.nome === "WHATSAPP"
                                          ? "(99) 9 9999-9999"
                                          : "99999999999999999999999"
                                      }
                                      style={{ width: "100%", height: "32px" }}
                                      value={this.state.contatoTelefonico}
                                      onChange={e => this.setState({contatoTelefonico: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="form-group">
                                    <label>E-mail</label>
                                    <InputText id="email" 
                                               type="text" 
                                               style={{width: '100%', height: '32px'}} 
                                               value={this.state.email}
                                               onChange={e => this.setState({email: e.target.value})}
                                               className="p-inputtext-sm p-d-block p-mb-1"/>
                                  </div>
                                </div>
                              </div>
                      </Dialog>

                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <label>Observação</label>
                            <InputTextarea id="observacao" 
                                           type="text" 
                                           style={{width: '100%'}} 
                                           value={this.state.observacao}
                                           onChange={e => this.setState({observacao: e.target.value})}
                                           className="p-inputtext-sm p-d-block p-mb-1"
                                           rows={12} cols={30}/>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header="Informações Complementares">
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Data de Cadastro</label>
                            <Calendar id="dataCadastro" 
                                      value={this.state.dataCadastro}
                                      disabled
                                      onChange={(e) => this.setState({ dataCadastro: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Última Alteração</label>
                            <Calendar id="dataUltimaAlteracao" 
                                      value={this.state.dataUltimaAlteracao}
                                      disabled
                                      onChange={(e) => this.setState({ dataUltimaAlteracao: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Dt. Nasc.</label>
                            <Calendar id="mask" 
                                      value={this.state.dataNascimento} 
                                      onChange={(e) => this.setState({ dataNascimento: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Profissão</label>
                            <InputText id="profissao" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.profissao}
                                        onChange={e => this.setState({profissao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Atividade Econômica</label>
                            <InputText id="atividadeEconomica" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.atividadeEconomica}
                                      onChange={e => this.setState({atividadeEconomica: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Estado Civil</label>
                            <Dropdown value={this.state.estadoCivil} 
                                      options={this.state.estadosCivil} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({estadoCivil: e.target.value})}
                                      id="estadoCivil"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Naturalidade</label>
                            <InputText id="naturalidades" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.naturalidade}
                                      onChange={e => this.setState({naturalidade: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Nacionalidade</label>
                            <InputText id="nacionalidade" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.nacionalidade}
                                      onChange={e => this.setState({nacionalidade: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Nome da Mãe</label>
                            <InputText id="nomeMae" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nomeMae}
                                      onChange={e => this.setState({nomeMae: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Nome do Pai</label>
                            <InputText id="nomePai" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nomePai}
                                      onChange={e => this.setState({nomePai: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <div className="row">
                     <div className="col-sm-5">
                      <div className="form-group">
                        <label>Grupo de Pessoas</label>
                        <Dropdown value={this.state.grupoCliente} 
                                  options={this.state.grupoPessoas} style={{width: '100%', height: '32px'}}
                                  onChange={this.onChangeGrupoPessoas} 
                                  optionLabel="nome"
                                  id="grupoCliente"
                                  filter showClear filterBy="nome"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                     </div>
                     <div className="col-sm-5">
                      <div className="form-group">
                        <label>Origem da Pessoa</label>
                        <Dropdown value={this.state.captador} 
                                  options={this.state.captadores} 
                                  onChange={this.onChangeCaptador} 
                                  optionLabel="nome" 
                                  filter showClear filterBy="nome"
                                  style={{width: '100%', height: '32px'}}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                     </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Conta Bancária</label>
                          <Dropdown value={this.state.tipoConta} 
                                    options={this.conta} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    onChange={e => this.setState({tipoConta: e.target.value})}
                                    id="cidade"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Número da Conta</label>
                          <InputText id="conta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.contaCorrente}
                                    onChange={e => this.setState({contaCorrente: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Variação Poupança</label>
                          <InputText id="varPaopupanca" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.variacaoPoupanca}
                                    onChange={e => this.setState({variacaoPoupanca: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Agência</label>
                          <InputText id="agencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.agencia}
                                    onChange={e => this.setState({agencia: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Banco</label>
                          <InputText id="agencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.banco}
                                    onChange={e => this.setState({banco: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-7">
                        <div className="form-group">
                          <label>Chave Pix</label>
                          <InputText id="pix" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pix}
                                      onChange={e => this.setState({pix: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    </TabPanel>
                    <TabPanel header="Documentação">
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>CPF</label>
                            <InputMask id="cpf" 
                                        type="text" 
                                        mask="999.999.999-99"
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.cpfCnpj}
                                        onChange={e => this.setState({cpfCnpj: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>RG</label>
                            <InputText id="RG" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.rg}
                                        onChange={e => this.setState({rg: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>Senha INSS</label>
                            <InputText id="sehaInss" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.senhaInss}
                                        onChange={e => this.setState({senhaInss: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoaJuridica}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CNPJ</label>
                            <InputMask id="cnpj" 
                                        type="text" 
                                        mask="99.999.999/9999-99"
                                        style={{width: '100%', height: '32px'}}
                                        value={this.state.cpfCnpj}
                                        onChange={e => this.setState({cpfCnpj: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CNH</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.cnh}
                                       onChange={e => this.setState({cnh: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CTPS</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.ctps}
                                       onChange={e => this.setState({ctps: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>PIS</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.pis}
                                       onChange={e => this.setState({pis: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Passaporte</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.passaporte}
                                       onChange={e => this.setState({passaporte: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Título de Eleitor</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.tituloEleitor}
                                       onChange={e => this.setState({tituloEleitor: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Certidão de Reservista</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.reservista}
                                       onChange={e => this.setState({reservista: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    </TabPanel>
                    <TabPanel header="Arquivos">
                      {/**Exibir Arquivo */}
                      <Dialog header="Arquivo"
                              visible={this.state.modalExibirArquivo} 
                              style={{ width: '60vw' }} 
                              footer={
                                <div>
                                    <Button label="Fechar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModalCadastro('modalExibirArquivo')}/>
                                </div>
                              }
                              onHide={() => this.fecharModalCadastro('modalExibirArquivo')}>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  
                                {this.state.fileData && (
                                    <div style={{ marginTop: "20px" }}>
                                        <h3>Arquivo:</h3>
                                        {this.state.fileName.toLowerCase().endsWith(".pdf") ? (
                                            <iframe
                                                src={this.state.fileData}
                                                title="PDF Viewer"
                                                style={{ width: "100%", height: "500px", border: "1px solid #ddd" }}
                                            />
                                        ) : (
                                            <img
                                                src={this.state.fileData}
                                                alt={this.state.fileName}
                                                style={{ maxWidth: "100%", maxHeight: "500px", border: "1px solid #ddd" }}
                                            />
                                        )}
                                    </div>
                                )}


                              </div>
                            </div>
                          </div>
                      </Dialog>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">  
                            <div className="container2">
                              
                              <Upload onUpload={this.handleUpload}/>
                              {!!upLoadFiles && (
                                <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                              )}
                            
                            </div>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                  emptyMessage="Nenhum Arquivo">
                        <Column field="arquivo" header="Arquivo"/>
                        <Column field="descricao" header="Descrição"></Column>
                        <Column field="usuario.nome" header="Usuário"></Column>
                        <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                      </DataTable> 
                      {/**Adicionar descrição ao arquivo */}
                      <Dialog header="Descrição do Arquivo"
                                  visible={this.state.modalDescricaoArquivo} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                                  onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="descricaoArquivo">Descrição</label>
                                  <InputText id="descricaoArquivo" 
                                        type="text" 
                                        style={{width: '100%', height: '37px'}} 
                                        value={this.state.descricao}
                                        onChange={e => this.setState({descricao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                      </Dialog>
                    </TabPanel>
                    <TabPanel header="Processos">
                      <DataTable value={this.state.processos}  paginator responsiveLayout="scroll"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                          selectionMode="multiple">
                          <Column field="pasta" header="Pasta"></Column>
                          <Column field="nrProcesso" header="Processo Original"></Column>
                          <Column field="nrCnj" header="Numeração Única"></Column>
                          <Column field="montaPartes" header="Partes" style={{width: '300px'}}></Column>
                          <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
                          <Column field="dataUltimaMovimentacao" header="Últ. Mov."></Column>
                          <Column field="statusProcessual.descricao" header="Status Processual"></Column>
                          <Column body={this.acoesProcessos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Histórico">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      data-toggle="modal" 
                                      onClick={() => this.abrirModalHistorico('modalHistorico')}
                                      data-target="#modal-default">
                              <i className="fas fa-plus"></i> Adicionar</button>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.historico}  paginator responsiveLayout="scroll"
                                 size="small"
                                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                 currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                 selectionMode="multiple">
                          <Column field="dsHistorico" header="Histórico"></Column>
                          <Column field="dataHistorico" header="Data"></Column>
                          <Column field="tipo" header="Tipo"></Column>
                          <Column field="usuario.nome" header="Usuário"></Column>
                          <Column body={this.acoesHistorico} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                      {/**Adicionar histórico de pessoa manualmente */}
                      <Dialog header="Histórico da Pessoa"
                                  visible={this.state.modalHistorico} 
                                  style={{ width: '45vw' }} 
                                  footer={this.renderFooterHistorico('modalHistorico')}
                                  onHide={() => this.fecharModalCadastro('modalHistorico')}>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <InputTextarea id="pedidos" 
                                             type="text" 
                                             style={{width: '100%'}} 
                                             value={this.state.descricaoHistorico}
                                             onChange={e => this.setState({descricaoHistorico: e.target.value})}
                                             className="p-inputtext-sm p-d-block p-mb-1"
                                             rows={15} cols={30}/>
                            </div>
                          </div>
                        </div>
                              
                      </Dialog>
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <div className="card">
                <div className="row">
                  <div className="col-sm-11">
                    <div className="form-group">
                      <div style={{textAlign: 'right'}}>
                        <Button label="Alterar" 
                                className="p-button-success p-button-text"
                                onClick={this.alterarPessoa}/>
                        &nbsp;
                        <a href={this.state.ficha} target="_blank" onClick={this.imprimirFicha}>
                          <Button label="Emitir Relatório"
                                  className="p-button-info p-button-text"/>
                        </a>        
                        &nbsp;
                        <Button label="Voltar" 
                            className="p-button-secondary p-button-text"
                            onClick={this.voltar}/>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    )
  }
}
ConsultarPessoa.contextType = AuthContext;
export default withRouter(ConsultarPessoa)
